import {useCountdownToDate} from '@countdown-timer';

type CampaignCountdownProps = {
  date: string;
};

const CampaignCountdown: React.FC<CampaignCountdownProps> = ({date}) => {
  const {timeRemaining} = useCountdownToDate({targetDate: new Date(date)});
  const countdown = typeof timeRemaining === 'string' ? '00 : 00 : 00 : 00' : timeRemaining.full;

  return (
    <section className="flex h-21 shrink-0 flex-col items-center justify-center gap-1 bg-white px-4">
      <h2 className="text-body-sm-emphasis text-gray-07">تا شروع دوره بعدی</h2>
      <bdi className="text-body-sm-emphasis text-neutral-fg">{countdown}</bdi>
    </section>
  );
};

export default CampaignCountdown;
